import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SubLedgerReportSummaryAccountingDocumentRequest {
  @observable
  accountingPeriod?: string;

  @observable
  sequenceName?: string;

  @observable
  sequenceNumber!: number;
}

export const SubLedgerReportSummaryAccountingDocumentRequestValidationRules: EntityValidationRules<SubLedgerReportSummaryAccountingDocumentRequest> =
  {
    accountingPeriod: {
      isLength: {
        max: 10,
        optional: true,
      },
    },
    sequenceName: {
      isLength: {
        max: 32,
        optional: true,
      },
    },
  };
